{
    "name": "frontend-inbox",
    "version": "1.0.13",
    "engines": {
        "node": ">=20.0.0",
        "npm": ">=10.0.0"
    },
    "scripts": {
        "ng": "ng",
        "start": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng serve --port 2400",
        "startIP": "ng serve --host 192.168.1.49 --port 1214",
        "build": "ng build",
        "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools && npm run i18n:extract:form && npm run i18n:extract:document && npm run i18n:extract:gif && npm run i18n:extract:reply && npm run i18n:extract:settings-menu && npm run i18n:extract:table && npm run i18n:extract:avatar",
        "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:form": "ngx-translate-extract -i ./src/sb-modules/Frontend-form-field-module -o ./src/sb-modules/Frontend-form-field-module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:document": "ngx-translate-extract -i ./src/sb-modules/Frontend-Document-Viewer-Module -o ./src/sb-modules/Frontend-Document-Viewer-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:gif": "ngx-translate-extract -i ./src/sb-modules/Frontend-GIF-Module -o ./src/sb-modules/Frontend-GIF-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:reply": "ngx-translate-extract -i ./src/sb-modules/Frontend-Reply-Templates-Module -o ./src/sb-modules/Frontend-Reply-Templates-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:settings-menu": "ngx-translate-extract -i ./src/sb-modules/Frontend-Settings-Menu-Module -o ./src/sb-modules/Frontend-Settings-Menu-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:table": "ngx-translate-extract -i ./src/sb-modules/Frontend-Table-Module -o ./src/sb-modules/Frontend-Table-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:avatar": "ngx-translate-extract -i ./src/sb-modules/Frontend-User-Avatar-Module -o ./src/sb-modules/Frontend-User-Avatar-Module/assets/i18n/en.json --sort -f json --clean",
        "prepare": "husky install",
        "prettier": "npx prettier --write ."
    },
    "private": true,
    "dependencies": {
        "@ali-hm/angular-tree-component": "^12.0.5",
        "@angular/animations": "^20.3.13",
        "@angular/common": "^20.3.13",
        "@angular/compiler": "^20.3.13",
        "@angular/core": "^20.3.13",
        "@angular/forms": "^20.3.13",
        "@angular/platform-browser": "^20.3.13",
        "@angular/platform-browser-dynamic": "^20.3.13",
        "@angular/router": "^20.3.13",
        "@ctrl/ngx-emoji-mart": "^9.3.0",
        "@fortawesome/fontawesome-free": "^7.0.1",
        "@giphy/js-fetch-api": "^4.2.0",
        "@microsoft/applicationinsights-web": "^2.5.10",
        "@microsoft/signalr": "^7.0.7",
        "@ng-select/ng-select": "^20.1.3",
        "@ngx-translate/core": "^15.0.0",
        "angular2-notifications": "^16.0.1",
        "autolinker": "^4.0.0",
        "color": "^4.2.3",
        "file-saver": "^2.0.5",
        "intl-tel-input": "^25.11.2",
        "jquery": "^3.7.1",
        "jspdf": "^3.0.1",
        "jspdf-autotable": "^5.0.2",
        "ngx-autosize": "^2.0.4",
        "ngx-avatars": "^1.8.0",
        "ngx-bootstrap": "^18.0.0",
        "ngx-clipboard": "^15.1.0",
        "ngx-doc-viewer": "^15.0.1",
        "ngx-dropzone-wrapper": "^14.0.0",
        "ngx-infinite-scroll": "^15.0.0",
        "ngx-linky": "^4.0.0",
        "ngx-quill": "26.0.10",
        "ngx-summernote": "^1.0.0",
        "ngx-translate-multi-http-loader": "^15.0.0",
        "ngx-ui-switch": "^14.0.3",
        "quill": "2.0.2",
        "quill-image-resize": "^3.0.9",
        "rxjs": "^7.8.0",
        "sanitize-html": "^2.17.0",
        "summernote": "^0.9.1",
        "tinycon": "^0.6.8",
        "tslib": "^2.3.1",
        "vanilla-js-wheel-zoom": "^6.12.0",
        "xlsx": "^0.18.5",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^20.3.11",
        "@angular/cli": "^20.3.11",
        "@angular/compiler-cli": "^20.3.13",
        "@types/jasmine": "^4.6.5",
        "@types/jquery": "^3.5.4",
        "@types/node": "^24.3.1",
        "@types/sanitize-html": "^2.16.0",
        "@vendure/ngx-translate-extract": "^10.1.3",
        "angular-eslint": "^20.0.0",
        "deepmerge-ts": "^4.2.2",
        "eslint": "^9.0.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-import": "^2.29.1",
        "eslint-plugin-jsdoc": "^48.7.0",
        "eslint-plugin-prettier": "^5.2.1",
        "husky": "^8.0.3",
        "jasmine-core": "~4.5.0",
        "jasmine-spec-reporter": "~7.0.0",
        "karma": "~6.4.1",
        "karma-chrome-launcher": "~3.1.1",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.0.0",
        "prettier": "3.3.3",
        "prettier-eslint": "^16.3.0",
        "typescript": "~5.8.3",
        "typescript-eslint": "^8.0.0"
    }
}
